import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'qmCapitalize'
})
export class QmCapitalizePipe implements PipeTransform {

  transform(value: string) {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
  }

}
